import React, { FunctionComponent } from "react";
import styles from "./card.module.scss";

const CardContainer: FunctionComponent = (props) => {
  return <div className={styles.card_container}>{props.children}</div>;
};

export default CardContainer;